// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BlogReel-module--wrapper--3b427","heading":"BlogReel-module--heading--1BfB6"};